import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./ResetPassword.module.css";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

const ResetNewPassword = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");
  const u_type = queryParams.get("u_type");
  const app_name = queryParams.get("app_name");
  const regionPrefix = queryParams.get("regionPrefix");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    setIsSubmitting(true);
    setMessage("");

    try {
      let response;

      // Special handling for user_type
      if (u_type === "user_type") {
        // Use different endpoint and include app_name
        const apiUrl = `https://${regionPrefix}.userauth2.${backend_api_base_url}/reset_password`;

        response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            token,
            password,
            u_type,
            app_name: app_name || "TESTINGdisablingonlylivechatbot"
          }),
        });
      } else {
        // Original flow for other u_type values
        response = await fetch(
          `https://auth2.${backend_api_base_url}/reset_forgot_password`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email,
              token,
              password,
              u_type: u_type
            }),
          }
        );
      }

      if (response.ok) {
        setMessage("Password reset successfully. You can now log in.");
      } else {
        const errorText = await response.text();
        setMessage(`Error: ${errorText}`);
      }
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Optional: Add validation to check if required params exist
  if (!token || !email || !u_type) {
    return (
      <div className={styles.resetPasswordContainer}>
        <h1 className={styles.title}>Invalid Reset Link</h1>
        <p className={styles.subtitle}>
          This password reset link is invalid or missing required information.
          Please request a new password reset.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.resetPasswordContainer}>
      <h1 className={styles.title}>Reset Your Password</h1>
      <p className={styles.subtitle}>
        Enter your new password below to reset your account.
      </p>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.inputGroup}>
          <label htmlFor="password" className={styles.label}>
            New Password
          </label>
          <input
            type="password"
            id="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="confirmPassword" className={styles.label}>
            Confirm New Password
          </label>
          <input
            type="password"
            id="confirmPassword"
            className={styles.input}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Reset Password"}
        </button>
      </form>

      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default ResetNewPassword;